import React, {ComponentProps, FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {AriaButtonLinkType} from '../../../types/AriaButtonLink';
import {Button as BaseButton} from './Button';

const Button: FC<
  ComponentProps<typeof BaseButton> & AriaButtonLinkType
> = props => {
  return <BaseButton {...props} />;
};

/**
 * @deprecated
 * Use atoms/ButtonsDeprecated/Button.tsx instead
 */
export const FullWidthButton = styled(Button)`
  width: 100%;
  box-shadow: none;
  border: 1px solid ${COLORS.Grey3};
`;
